import * as React from "react";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  className?: string;
  outline?: boolean;
  caps?: boolean;
  bold?: boolean;
};

export default class Badge extends React.PureComponent<React.PropsWithChildren<Props>> {
  render() {
    const { children, className, outline, caps, bold, ...props } = this.props;

    const badgeClassNames = twMerge(
      classNames(
        "badge ml-1 tabular-numerals",
        outline ? "badge--outline" : "badge--solid",
        caps && "uppercase tracking-widest",
        bold && "semi-bold",
      ),
      className,
    );

    return (
      <span className={badgeClassNames} {...props}>
        {children}
      </span>
    );
  }
}
